import type { TAirbridgeObject } from './airbridge-object'

export enum SUCCESS {
  '001' = 'SCSS_001', // 성공
}

export enum COMMON {
  '001' = 'COMN_001', // toast/alert 메시지 출력
}

export enum AUTH {
  '001' = 'AUTH_001', // 로그인 시 이메일 주소 또는 비밀번호가 일치하지 않음 (401)
  '002' = 'AUTH_002', // 인증 정보 없음 (401)
  '003' = 'AUTH_003', // 접근 권한 없음 (403)
  '004' = 'AUTH_004', // 액세스 토큰 만료 (401)
  '005' = 'AUTH_005', // 토큰 유효성 검사 실패 (401)
  '006' = 'AUTH_006', // 리프레시 토큰 만료 (401)
}

export enum USER {
  '001' = 'USER_001', // 유저를 찾을 수 없음
  '002' = 'USER_002', // 이메일 중복
  '003' = 'USER_003', // 전화번호 중복
  '004' = 'USER_004', // 정지 이력 존재
  '005' = 'USER_005', // 본인 인증 정보 없음
  '006' = 'USER_006', // 본인 인증 정보 만료
  '007' = 'USER_007', // di값 중복
  '008' = 'USER_008', // 탈퇴 후 30일 이내 재가입 시도
  '009' = 'USER_009', // 유효하지 않은 계좌 정보
  '010' = 'USER_010', // 이미 호스트로 가입된 계정
  '011' = 'USER_011', // 호스트 회원가입을 위해 휴대폰 인증이 필요
  '012' = 'USER_012', // 가입 정보를 찾을 수 없음
  '013' = 'USER_013', // 가입 시 인증정보와 불일치
}

export enum PAY {
  '001' = 'PAY_001', // 존재하지 않는 주문번호
  '002' = 'PAY_002', // 결제 금액 불일치
  '003' = 'PAY_003', // 결제할 수 없는 상태
  '004' = 'PAY_004', // 결제 마감 시간 초과
  '005' = 'PAY_005', // 결제 승인 실패
  '010' = 'PAY_010', // PG사 통신 실패
}

export enum ROOM {
  '001' = 'ROOM_001', // 존재하지 않는 방
  '002' = 'ROOM_002', // 공개 또는 등록되지 않은 방
}

export enum CONTRACT {
  '001' = 'CTR_001', // 계약을 찾을 수 없음
  '002' = 'CTR_002', // 계약 상태가 올바르지 않음
  '003' = 'CTR_003', // 취소된 계약
  '004' = 'CTR_004', // 이미 결제 완료된 계약
  '005' = 'CTR_005', // 결제 마감 시한이 지남
  '006' = 'CTR_006', // 연장 계약이 있어서 취소 불가능
  '007' = 'CTR_007', // 결제 불가능한 계약
  '008' = 'CTR_008', // 본인 인증이 완료된 회원만 계약 가능
  '009' = 'CTR_009', // 19세 미만 이용 제한
  '010' = 'CTR_010', // 하루 최대 승인 요청 횟수 도달
  '011' = 'CTR_011', // 입주일 1년 이내만 선택 가능
  '012' = 'CTR_012', // 지난 날짜 입주일 선택 불가능
  '013' = 'CTR_013', // 계약 기간 7일 미만
  '014' = 'CTR_014', // 주 단위가 아닌 계약 기간
  '015' = 'CTR_015', // 존재하지 않는 방
  '016' = 'CTR_016', // 호스트에게 임대료 문의 필요
  '017' = 'CTR_017', // 계약 불가능한 일정 포함
  '018' = 'CTR_018', // 해당 방에 이미 진행 중인 계약 존재
  '019' = 'CTR_019', // 연장 계약 요청이 불가능한 계약
  '020' = 'CTR_020', // 이용 규정 위반으로 이용이 정지된 회원
  '021' = 'CTR_021', // 이미 승인된 계약
  '022' = 'CTR_022', // 계약 불가능한 일정
  '023' = 'CTR_023', // 연장 계약 날짜 오류
  '024' = 'CTR_024', // 연장 가능한 계약을 찾을 수 없음
  '025' = 'CTR_025', // 보증금 반환 요청되지 않은 계약 - 퇴실 확인 실패
  '026' = 'CTR_026', // 보증금 반환 요청되지 않은 계약 - 퇴실 보류 실패
  '027' = 'CTR_027', // 연장 계약이 있어 퇴실 불가능
  '028' = 'CTR_028', // 보증금 반환 계좌가 없음
}

export enum VALID {
  '001' = 'VLD_001', // 필수 파라미터가 유효하지 않음
  '002' = 'VLD_002', // 필수 헤더가 유효하지 않음
}

export enum SYSTEM {
  '001' = 'SYS_001', // 처리되지 않은 예외 발생
}

export enum ADDRESS {
  '001' = 'ADDR_001', // 상세한 주소 입력 필요
}

export enum CARE {
  '001' = 'CARE_001', // 이미 접수가 완료됨
  '002' = 'CARE_002', // 유효하지 않은 접수 링크
  '003' = 'CARE_003', // 접수 링크가 만료
}

export enum CERT {
  '003' = 'CERT_003', // 여권 OCR 기술적 실패
  '004' = 'CERT_004', // 여권 이미지가 아님
  '005' = 'CERT_005', // 여권 정보 판독 불가 (이미지 불선명)
  '006' = 'CERT_006', // 만료된 여권
  '007' = 'CERT_007', // 이메일 인증코드 발송 횟수 초과 (10분 내 5회)
  '008' = 'CERT_008', // 인증코드 만료 (유효기간 5분)
  '009' = 'CERT_009', // 인증코드 불일치
  '010' = 'CERT_010', // emailCertToken 만료 또는 email 불일치
  '099' = 'CERT_099', // Gemini 429 또는 중복 여권
}

export type ResponseCode =
  | SUCCESS
  | COMMON
  | AUTH
  | USER
  | PAY
  | ROOM
  | CONTRACT
  | VALID
  | SYSTEM
  | ADDRESS
  | CARE
  | CERT

export enum MessageType {
  TOAST = 'TOAST', // 토스트 메시지 출력
  ALERT = 'ALERT', // 제목, 내용 및 확인 버튼
  CONFIRM = 'CONFIRM', // 제목, 내용 및 확인/취소 버튼
}

export type ResponseMessage = {
  type: MessageType
  title?: string
  content: string
}

export type SuccessResponse<T> = {
  code: SUCCESS
  data: T
  message?: ResponseMessage
  airbridgeObject?: TAirbridgeObject
}

export type ErrorResponse = {
  code: Exclude<ResponseCode, SUCCESS>
  data?: unknown
  message?: ResponseMessage
}

export type ApiResponse<T = unknown> = SuccessResponse<T> | ErrorResponse

export const isSuccessResponse = <T>(
  res: Response,
  json: ApiResponse<T>,
): json is SuccessResponse<T> => {
  return res.ok && json.code === SUCCESS['001']
}
